import { Flex, HStack } from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import React from "react";

import { Button } from "newui/components/Button";

type RfxSupplierListHeaderProps = {
	isDraft: boolean;
	suppliersSelected: number;
	totalSuppliers: number;
	navigateCompareSelected: (page: string) => Promise<void>;
};

export const RfxSupplierListHeader: React.FC<RfxSupplierListHeaderProps> = ({
	isDraft,
	navigateCompareSelected,
	suppliersSelected,
	totalSuppliers,
}) => {
	const hasSelectedSuppliers = suppliersSelected > 0;
	const headerText = isDraft ? "Suppliers" : "All Invited Suppliers";

	return (
		<div className="w-full rounded-t-2xl border-gray-200 p-6">
			<div className="flex items-center justify-between gap-4">
				<div className="flex flex-col items-baseline gap-1">
					<HStack>
						<h2 className="text-lg font-semibold text-primary-900">
							{headerText}
						</h2>
						{hasSelectedSuppliers && (
							<div className="pl-5 text-sm">
								{suppliersSelected} selected of {totalSuppliers}
							</div>
						)}
					</HStack>
				</div>
				{hasSelectedSuppliers && (
					<div className="flex items-center gap-4">
						<Button
							type="button"
							btntype="base"
							className="!px-3 !py-2"
							onClick={() => navigateCompareSelected("compare")}
						>
							<Flex
								align={"center"}
								className="gap-2"
							>
								<Icon
									icon="switch-horizontal"
									color="#0031DD"
								/>
								<p className="font-roboto font-semibold">Compare Selected</p>
							</Flex>
						</Button>

						<Button
							type="button"
							btntype="secondary"
							className="!px-3 !py-2"
							onClick={() => navigateCompareSelected("shortlist")}
						>
							<Flex
								align={"center"}
								className="gap-2"
							>
								<Icon icon="download" />
								<p className="font-roboto font-semibold text-utility-blue-dark-100">
									Shortlist
								</p>
							</Flex>
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};
